<div
  class="mr-5 mt-2"
  *ngIf="!!chart"
  [ngClass]="{
    'pb-10': chartOptionsIsExpanded === true || isReport === true,
    'ml-5': isReport === true,
    'ml-3': isReport === false
  }"
>
  <!-- <div
    *ngIf="isReport === false"
    class="text-s500 mb-5 flex select-none flex-row justify-start font-semibold"
  >
    CHART FIELDS
  </div> -->

  <ng-container *ngIf="canAccessModel !== false || isReport === true">
    <div
      *ngIf="
        isReport === false && uiChartTypes.pivotRows.indexOf(chart.type) > -1
      "
      class="mb-7 ml-2 flex flex-col items-stretch"
    >
      <div class="mt-1 flex flex-col items-stretch gap-3">
        <div class="flex w-max min-w-[220px] flex-col items-stretch">
          <div
            class="text-s500 flex h-7 select-none items-center text-base font-semibold"
            >Rows</div
          >

          <div
            #pivotRowDimensionsList
            id="pivotRowDimensions"
            cdkDropList
            [cdkDropListData]="pivotRowColumns"
            [cdkDropListConnectedTo]="['pivotColumnDimensions']"
            [style.height]="pivotRowDimensionsListHeight"
            (cdkDropListDropped)="pivotDimensionsDrop({ event: $event })"
            class="border-s300 mt-1 flex min-h-[50px] w-max min-w-[220px] flex-col items-stretch space-y-1 rounded border p-2"
          >
            <div
              *ngFor="let column of pivotRowColumns"
              cdkDrag
              class="drag-handle flex w-full cursor-grab flex-row items-center rounded px-2 py-1"
              [ngClass]="{ 'hover:bg-s100': isPivotDrag === false }"
              (cdkDragStarted)="pivotDragStart({ section: 'rows' })"
              (cdkDragEnded)="pivotDragEnd({})"
            >
              <m-pivot-drag-icon
                class="text-s500 -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
              ></m-pivot-drag-icon>

              <m-field-result
                class="mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                [ngClass]="{
                  '-mt-[2px]': column.result === fieldResultEnum.String
                }"
                [size]="2"
                [fieldClass]="column.fieldClass"
                [result]="column.result"
              ></m-field-result>

              <m-field-label
                [column]="column"
                class="flex min-w-0 flex-1 text-[15px]"
              ></m-field-label>

              <div
                *cdkDragPreview
                class="border-s300 bg-m0 flex cursor-grabbing flex-row items-center rounded border px-3 py-2 shadow-lg"
              >
                <m-pivot-drag-icon
                  class="text-s500 -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
                ></m-pivot-drag-icon>

                <m-field-result
                  class="mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                  [ngClass]="{
                    '-mt-[2px]': column.result === fieldResultEnum.String
                  }"
                  [size]="2"
                  [fieldClass]="column.fieldClass"
                  [result]="column.result"
                ></m-field-result>

                <m-field-label
                  [column]="column"
                  class="flex min-w-[220px] text-[15px]"
                ></m-field-label>
              </div>

              <div
                *cdkDragPlaceholder
                class="outline-s300 flex w-full flex-row items-center rounded px-2 py-1 outline outline-dashed outline-1 -outline-offset-1"
              >
                <m-pivot-drag-icon
                  class="text-s500 invisible -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
                ></m-pivot-drag-icon>

                <m-field-result
                  class="invisible mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                  [ngClass]="{
                    '-mt-[2px]': column.result === fieldResultEnum.String
                  }"
                  [size]="2"
                  [fieldClass]="column.fieldClass"
                  [result]="column.result"
                ></m-field-result>

                <m-field-label
                  [column]="column"
                  class="invisible flex min-w-0 flex-1 text-[15px]"
                ></m-field-label>
              </div>
            </div>
          </div>
        </div>

        <div class="flex w-max min-w-[220px] flex-col items-stretch">
          <div
            class="text-s500 flex h-7 select-none items-center text-base font-semibold"
            >Columns</div
          >

          <div
            #pivotColumnDimensionsList
            id="pivotColumnDimensions"
            cdkDropList
            [cdkDropListData]="pivotColumnColumns"
            [cdkDropListConnectedTo]="['pivotRowDimensions']"
            [style.height]="pivotColumnDimensionsListHeight"
            (cdkDropListDropped)="pivotDimensionsDrop({ event: $event })"
            class="border-s300 mt-1 flex min-h-[50px] w-max min-w-[220px] flex-col items-stretch space-y-1 rounded border p-2"
          >
            <div
              *ngFor="let column of pivotColumnColumns"
              cdkDrag
              class="drag-handle flex w-full cursor-grab flex-row items-center rounded px-2 py-1"
              [ngClass]="{ 'hover:bg-s100': isPivotDrag === false }"
              (cdkDragStarted)="pivotDragStart({ section: 'columns' })"
              (cdkDragEnded)="pivotDragEnd({})"
            >
              <m-pivot-drag-icon
                class="text-s500 -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
              ></m-pivot-drag-icon>

              <m-field-result
                class="mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                [ngClass]="{
                  '-mt-[2px]': column.result === fieldResultEnum.String
                }"
                [size]="2"
                [fieldClass]="column.fieldClass"
                [result]="column.result"
              ></m-field-result>

              <m-field-label
                [column]="column"
                class="flex min-w-0 flex-1 text-[15px]"
              ></m-field-label>

              <div
                *cdkDragPreview
                class="border-s300 bg-m0 flex cursor-grabbing flex-row items-center rounded border px-3 py-2 shadow-lg"
              >
                <m-pivot-drag-icon
                  class="text-s500 -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
                ></m-pivot-drag-icon>

                <m-field-result
                  class="mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                  [ngClass]="{
                    '-mt-[2px]': column.result === fieldResultEnum.String
                  }"
                  [size]="2"
                  [fieldClass]="column.fieldClass"
                  [result]="column.result"
                ></m-field-result>

                <m-field-label
                  [column]="column"
                  class="flex min-w-[220px] text-[15px]"
                ></m-field-label>
              </div>

              <div
                *cdkDragPlaceholder
                class="outline-s300 flex w-full flex-row items-center rounded px-2 py-1 outline outline-dashed outline-1 -outline-offset-1"
              >
                <m-pivot-drag-icon
                  class="text-s500 invisible -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
                ></m-pivot-drag-icon>

                <m-field-result
                  class="invisible mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                  [ngClass]="{
                    '-mt-[2px]': column.result === fieldResultEnum.String
                  }"
                  [size]="2"
                  [fieldClass]="column.fieldClass"
                  [result]="column.result"
                ></m-field-result>

                <m-field-label
                  [column]="column"
                  class="invisible flex min-w-0 flex-1 text-[15px]"
                ></m-field-label>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="uiChartTypes.pivotValues.indexOf(chart.type) > -1"
          class="flex w-max min-w-[220px] flex-col items-stretch"
        >
          <div
            class="text-s500 flex h-7 select-none items-center text-base font-semibold"
            >Values</div
          >

          <div
            #pivotValuesList
            cdkDropList
            [cdkDropListData]="pivotValueColumns"
            [style.height]="pivotValuesListHeight"
            (cdkDropListDropped)="pivotValuesDrop({ event: $event })"
            class="border-s300 mt-1 flex min-h-[50px] w-max min-w-[220px] flex-col items-stretch space-y-1 rounded border p-2"
          >
            <div
              *ngFor="let column of pivotValueColumns"
              cdkDrag
              class="drag-handle flex w-full cursor-grab flex-row items-center rounded px-2 py-1"
              [ngClass]="{ 'hover:bg-s100': isPivotDrag === false }"
              (cdkDragStarted)="pivotDragStart({ section: 'values' })"
              (cdkDragEnded)="pivotDragEnd({})"
            >
              <m-pivot-drag-icon
                class="text-s500 -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
              ></m-pivot-drag-icon>

              <m-field-result
                class="mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                [ngClass]="{
                  '-mt-[2px]': column.result === fieldResultEnum.String
                }"
                [size]="2"
                [fieldClass]="column.fieldClass"
                [result]="column.result"
              ></m-field-result>

              <m-field-label
                [column]="column"
                class="flex min-w-0 flex-1 text-[15px]"
              ></m-field-label>

              <div
                *cdkDragPreview
                class="border-s300 bg-m0 flex cursor-grabbing flex-row items-center rounded border px-3 py-2 shadow-lg"
              >
                <m-pivot-drag-icon
                  class="text-s500 -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
                ></m-pivot-drag-icon>

                <m-field-result
                  class="mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                  [ngClass]="{
                    '-mt-[2px]': column.result === fieldResultEnum.String
                  }"
                  [size]="2"
                  [fieldClass]="column.fieldClass"
                  [result]="column.result"
                ></m-field-result>

                <m-field-label
                  [column]="column"
                  class="flex min-w-[220px] text-[15px]"
                ></m-field-label>
              </div>

              <div
                *cdkDragPlaceholder
                class="outline-s300 flex w-full flex-row items-center rounded px-2 py-1 outline outline-dashed outline-1 -outline-offset-1"
              >
                <m-pivot-drag-icon
                  class="text-s500 invisible -mt-[2px] mr-2 flex h-5 w-5 flex-shrink-0"
                ></m-pivot-drag-icon>

                <m-field-result
                  class="invisible mr-3 flex h-4 w-4 flex-shrink-0 items-center justify-center"
                  [ngClass]="{
                    '-mt-[2px]': column.result === fieldResultEnum.String
                  }"
                  [size]="2"
                  [fieldClass]="column.fieldClass"
                  [result]="column.result"
                ></m-field-result>

                <m-field-label
                  [column]="column"
                  class="invisible flex min-w-0 flex-1 text-[15px]"
                ></m-field-label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="isReport === false && uiChartTypes.format.indexOf(chart.type) > -1"
      class="mb-5 ml-2 flex max-w-min cursor-pointer flex-row items-center"
      (click)="toggleFormat()"
    >
      <div
        class="text-s1 flex h-9 flex-shrink-0 select-none items-center text-base"
        >Format</div
      >

      <ui-switch
        class="ml-5 mt-1"
        [checked]="chart.format"
        color="#64BD63"
      ></ui-switch>
    </div>

    <!-- <div
    *ngIf="
      isReport === false && uiChartTypes.hideColumns.indexOf(chart.type) > -1
    "
    class="mb-5 ml-2 flex flex-row items-start"
  >
    <div class="text-s1 flex h-9 select-none items-center text-base"
      >Hide Columns</div
    >

    <div class="ml-5 mt-2 flex flex-col items-start space-y-4">
      <div
        *ngFor="let column of mconfigFields"
        class="flex flex-row items-center"
      >
        <button
          data-cy="chartEditorHideColumnsCheckbox"
          class="border-m600 text-m0 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded border-2 focus:outline-none"
          [ngClass]="{
            'bg-m600': hideColumnsIsChecked(column.id)
          }"
          (click)="hideColumnsOnClick(column.id)"
        >
          <m-check-icon *ngIf="hideColumnsIsChecked(column.id)"></m-check-icon>
        </button>

        <m-field-label [column]="column" class="ml-3 text-sm"></m-field-label>
      </div>
    </div>
  </div> -->

    <div
      *ngIf="isReport === false && uiChartTypes.xField.indexOf(chart.type) > -1"
      class="mb-5 ml-2 flex flex-row items-start"
    >
      <div class="flex flex-col">
        <div
          class="text-s500 flex h-9 w-[100px] select-none items-center text-base font-semibold"
          >X Field</div
        >
      </div>

      <form [formGroup]="xFieldForm" class="ml-5 min-w-[2px] flex-grow">
        <ng-select
          #xFieldSelect
          [fixNgSelectBottom]="xFieldSelect"
          data-cy="xFieldSelect"
          class="select-none text-base"
          [items]="
            chart.type === chartTypeEnum.Scatter
              ? dimensionsMeasuresCalculations
              : dimensions
          "
          [clearable]="false"
          [searchable]="false"
          (change)="xFieldChange()"
          (keyup.esc)="$event.stopImmediatePropagation(); xFieldSelect.blur()"
          (keyup.enter)="$event.stopImmediatePropagation(); xFieldSelect.blur()"
          appendTo="body"
          bindLabel="label"
          bindValue="id"
          formControlName="xField"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
              ></m-field-result>

              <m-field-label
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
              ></m-field-result>

              <m-field-label
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
        </ng-select>
      </form>
    </div>

    <div
      *ngIf="
        isReport === false && uiChartTypes.sizeField.indexOf(chart.type) > -1
      "
      class="mb-5 ml-2 flex flex-row items-start"
    >
      <div class="flex flex-col">
        <div
          class="text-s500 flex h-9 w-[100px] select-none items-center text-base font-semibold"
          >Size Field</div
        >
      </div>

      <form [formGroup]="sizeFieldForm" class="ml-5 min-w-[2px] flex-grow">
        <ng-select
          #sizeFieldSelect
          [fixNgSelectBottom]="sizeFieldSelect"
          data-cy="sizeFieldSelect"
          class="select-none text-base"
          [items]="numbersDimensionsMeasuresCalculationsPlusEmpty"
          [clearable]="false"
          [searchable]="false"
          (change)="sizeFieldChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation(); sizeFieldSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); sizeFieldSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="id"
          formControlName="sizeField"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
                [isEmpty]="!item.id"
              ></m-field-result>

              <m-field-label
                *ngIf="!!item.id"
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
                [isEmpty]="!item.id"
              ></m-field-result>

              <m-field-label
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
        </ng-select>
      </form>
    </div>

    <div
      *ngIf="
        isReport === false && uiChartTypes.multiField.indexOf(chart.type) > -1
      "
      class="mb-5 ml-2 flex flex-row items-start"
    >
      <div class="flex flex-col">
        <div
          class="text-s500 flex h-9 w-[100px] select-none items-center text-base font-semibold"
          >Multi Field</div
        >
      </div>

      <form
        [formGroup]="multiFieldForm"
        class="ml-5 min-w-[2px] flex-grow"
        *ngIf="
          (chart.type !== chartTypeEnum.Scatter && dimensions.length > 1) ||
          (chart.type === chartTypeEnum.Scatter && dimensions.length > 0)
        "
      >
        <ng-select
          #multiFieldSelect
          [fixNgSelectBottom]="multiFieldSelect"
          data-cy="multiFieldSelect"
          class="select-none text-base"
          [items]="
            uiChartTypes.nullableMultiField.indexOf(chart.type) > -1
              ? dimensionsPlusEmpty
              : dimensions
          "
          [clearable]="false"
          [searchable]="false"
          (change)="multiFieldChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation(); multiFieldSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); multiFieldSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="id"
          formControlName="multiField"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
                [isEmpty]="!item.id"
              ></m-field-result>

              <m-field-label
                *ngIf="!!item.id"
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
                [isEmpty]="!item.id"
              ></m-field-result>

              <m-field-label
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
        </ng-select>
      </form>

      <div
        *ngIf="
          (chart.type !== chartTypeEnum.Scatter && dimensions.length < 2) ||
          (chart.type === chartTypeEnum.Scatter && dimensions.length < 1)
        "
        class="text-s1 ml-8 flex h-9 select-none items-center text-base"
        ><m-minus-sm-icon></m-minus-sm-icon
      ></div>
    </div>

    <div
      *ngIf="isReport === false && uiChartTypes.yField.indexOf(chart.type) > -1"
      class="mb-5 ml-2 flex flex-row items-start"
    >
      <div class="flex flex-col">
        <div
          class="text-s500 flex h-9 w-[100px] select-none items-center text-base font-semibold"
          >Y Field</div
        >
      </div>

      <form [formGroup]="yFieldForm" class="ml-5 min-w-[2px] flex-grow">
        <ng-select
          #yFieldSelect
          [fixNgSelectBottom]="yFieldSelect"
          data-cy="yFieldSelect"
          class="select-none text-base"
          [items]="numbersMeasuresAndCalculations"
          [clearable]="false"
          [searchable]="false"
          (change)="yFieldChange()"
          (keyup.esc)="$event.stopImmediatePropagation(); yFieldSelect.blur()"
          (keyup.enter)="$event.stopImmediatePropagation(); yFieldSelect.blur()"
          appendTo="body"
          bindLabel="label"
          bindValue="id"
          formControlName="yField"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
              ></m-field-result>

              <m-field-label
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 flex flex-row items-center">
              <m-field-result
                class="h-5 w-5"
                [size]="2"
                [fieldClass]="item.fieldClass"
                [result]="item.result"
              ></m-field-result>

              <m-field-label
                [column]="item"
                class="ml-3 flex text-sm"
              ></m-field-label>
            </div>
          </ng-template>
        </ng-select>
      </form>
    </div>

    <div
      *ngIf="
        isReport === false && uiChartTypes.yFields.indexOf(chart.type) > -1
      "
      class="mb-5 ml-2 flex flex-row items-start"
    >
      <div
        class="text-s500 flex h-9 w-[100px] select-none items-center text-base font-semibold"
        >Y Fields</div
      >

      <div class="ml-5 mt-2 flex flex-col items-start space-y-4">
        <div
          *ngFor="let column of numbersYFields"
          class="flex flex-row items-center"
        >
          <div class="ml-3 flex flex-row items-center">
            <button
              data-cy="chartEditorYFieldsCheckbox"
              class="border-m600 text-m0 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded border-2 focus:outline-none"
              [ngClass]="{
                'bg-m600': yFieldsIsChecked(column.id)
              }"
              (click)="yFieldsOnClick(column.id)"
            >
              <m-check-icon *ngIf="yFieldsIsChecked(column.id)"></m-check-icon>
            </button>

            <!-- <m-field-result
            class="ml-3 mt-1 h-5 w-5"
            [size]="2"
            [fieldClass]="column.fieldClass"
            [result]="column.result"
          ></m-field-result> -->

            <m-field-label
              [column]="column"
              class="ml-3 flex text-sm"
            ></m-field-label>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        isReport === false &&
        [chartTypeEnumTable, chartTypeEnumSingle].indexOf(chart?.type) < 0
      "
      class="text-s500 mt-7 flex h-12 w-fit cursor-pointer select-none flex-row items-start justify-start pr-5 font-semibold"
      (click)="toggleChartOptions()"
    >
      <m-chevron-right-icon
        *ngIf="chartOptionsIsExpanded === false"
      ></m-chevron-right-icon>
      <m-chevron-down-icon
        *ngIf="chartOptionsIsExpanded === true"
      ></m-chevron-down-icon>

      <div class="ml-2"> CHART OPTIONS </div>
    </div>

    <div
      *ngIf="isReport === true"
      class="text-s500 mt-5 flex h-12 select-none flex-row items-start justify-start pl-2 pr-5 font-semibold"
    >
      <div> CHART OPTIONS </div>
    </div>

    <div
      *ngIf="
        chartOptionsIsExpanded === true &&
        uiChartTypes.pivot.indexOf(chart.type) > -1
      "
      class="flex flex-col pl-5"
    >
      <div
        *ngIf="isDebugPivot === true"
        class="mb-5 ml-[32px] flex flex-row items-center"
      >
        <div
          class="text-s1 flex h-9 w-[160px] flex-shrink-0 select-none items-center text-base"
          >Theme</div
        >

        <select
          class="form-select border-s300 ml-5 h-9 rounded text-sm"
          [value]="chart.pivotTheme || 'standard'"
          (change)="pivotThemeChange($event)"
        >
          <option *ngFor="let theme of pivotThemeList" [value]="theme.value">
            {{ theme.label }}
          </option>
        </select>
      </div>

      <div class="mb-5 ml-[32px] flex flex-row items-center">
        <div
          class="text-s1 flex h-9 w-[160px] flex-shrink-0 select-none items-center text-base"
          >First column width</div
        >

        <input
          class="border-s300 ml-5 h-9 w-24 rounded border px-2 text-sm"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          [value]="chart.firstColumnWidth || defaultPivotFirstColumnWidth"
          (change)="
            pivotWidthChange({
              event: $event,
              field: 'firstColumnWidth'
            })
          "
        />
      </div>

      <div class="mb-5 ml-[32px] flex flex-row items-center">
        <div
          class="text-s1 flex h-9 w-[160px] flex-shrink-0 select-none items-center text-base"
          >Value columns width</div
        >

        <input
          class="border-s300 ml-5 h-9 w-24 rounded border px-2 text-sm"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          [value]="chart.valueColumnsWidth || defaultPivotColumnsWidth"
          (change)="
            pivotWidthChange({
              event: $event,
              field: 'valueColumnsWidth'
            })
          "
        />
      </div>
    </div>

    <div
      *ngIf="
        (chartOptionsIsExpanded === true || isReport === true) &&
        uiChartTypes.seriesGroup.indexOf(chart.type) > -1
      "
      class="flex flex-col"
      [ngClass]="{
        'pl-5': isReport === false
      }"
    >
      <div
        *ngFor="let seriesElement of chartSeriesWithField; let i = index"
        class="flex flex-col"
      >
        <m-chart-editor-series-element
          [seriesElement]="seriesElement"
          [yAxisIndexList]="yAxisIndexList"
          [isReport]="isReport"
          [isExpanded]="
            isReport === true
              ? seriesToggleExpandList.indexOf(seriesElement.dataRowId) > -1
              : seriesToggleExpandList.indexOf(seriesElement.dataField) < 0
          "
          (chartToggleSeries)="chartToggleSeries($event)"
          (chartSeriesElementUpdate)="chartSeriesElementUpdate($event)"
        ></m-chart-editor-series-element>
      </div>
    </div>

    <div
      *ngIf="
        (chartOptionsIsExpanded === true || isReport === true) &&
        uiChartTypes.xAxisGroup.indexOf(chart.type) > -1
      "
      class="flex flex-col"
      [ngClass]="{
        'pl-5': isReport === false
      }"
    >
      <div
        (click)="toggleXAxis()"
        class="text-s1 mb-5 flex w-[100px] cursor-pointer select-none flex-row items-start text-lg font-semibold"
      >
        <div class="flex flex-row items-center">
          <m-chevron-right-icon *ngIf="!xAxisIsExpanded"></m-chevron-right-icon>
          <m-chevron-down-icon *ngIf="xAxisIsExpanded"></m-chevron-down-icon>

          <div class="ml-2"> X Axis </div>
        </div>
      </div>

      <div *ngIf="xAxisIsExpanded" class="flex flex-col">
        <div
          *ngIf="
            uiChartTypes.xAxis.scale.indexOf(chart.type) > -1 &&
            isReport === false &&
            xFieldResult === fieldResultEnum.Number
          "
          class="mb-5 ml-[32px] flex max-w-min cursor-pointer flex-row items-center"
          (click)="toggleXAxisScale()"
        >
          <div
            class="text-s1 flex h-9 w-[50px] flex-shrink-0 select-none items-center text-base"
            >Scale</div
          >

          <ui-switch class="ml-5" [checked]="chart.xAxis.scale"></ui-switch>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        (chartOptionsIsExpanded === true || isReport === true) &&
        uiChartTypes.yAxisGroup.indexOf(chart.type) > -1
      "
      class="flex flex-col"
      [ngClass]="{
        'pl-5': isReport === false
      }"
    >
      <!-- <div class="flex flex-row">
      <div
        (click)="toggleYAxis()"
        class="text-s1 mb-5 flex cursor-pointer select-none flex-row items-start text-lg font-semibold"
      >
        <div class="flex flex-row items-center">
          <m-chevron-right-icon *ngIf="!yAxisIsExpanded"></m-chevron-right-icon>
          <m-chevron-down-icon *ngIf="yAxisIsExpanded"></m-chevron-down-icon>

          <div class="ml-2"> Y Axis </div>
        </div>
      </div>

      <button
        *ngIf="yAxisIsExpanded === true || chart.yAxis.length === 0"
        type="button"
        data-cy="chartEditorAddYAxisButton"
        class="ml-5 h-7 flex-shrink-0 select-none rounded border border-s400 px-[2px] py-[0px] text-sm font-medium text-s500 hover:bg-m0 focus:outline-none"
        (click)="addYAxis()"
        ><m-add-icon></m-add-icon
      ></button>
    </div> -->

      <div *ngIf="yAxisIsExpanded" class="flex flex-col">
        <div
          *ngFor="let yAxisElement of chart.yAxis; let i = index"
          class="flex flex-col"
        >
          <m-chart-editor-y-axis-element
            class="flex"
            [yAxisIndex]="i"
            [yAxisElement]="yAxisElement"
            [isExpanded]="
              isReport === true
                ? yAxisToggleExpandList.indexOf(i) > -1
                : yAxisToggleExpandList.indexOf(i) < 0
            "
            [chartType]="chart.type"
            (chartDeleteYAxisElement)="chartDeleteYAxisElement($event)"
            (chartToggleYAxisElement)="chartToggleYAxisElement($event)"
            (chartYAxisElementUpdate)="chartYAxisElementUpdate($event)"
          ></m-chart-editor-y-axis-element>
        </div>
      </div>
    </div>

    <!-- <div
    *ngIf="colorSchemeChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Color Scheme</div
      >
    </div>

    <form [formGroup]="colorSchemeForm" class="ml-5 min-w-[2px] flex-grow">
      <ng-select
        #colorSchemeSelect
        [fixNgSelectBottom]="colorSchemeSelect"
        data-cy="colorSchemeSelect"
        class="text-base select-none"
        [items]="colorSchemesList"
        [clearable]="false"
        [searchable]="false"
        (change)="colorSchemeChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); colorSchemeSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); colorSchemeSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
        formControlName="colorScheme"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 flex">{{ item.label }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 flex">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </form>
  </div> -->

    <!-- <div
    *ngIf="schemeTypeChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Scheme Type</div
      >
    </div>

    <form [formGroup]="schemeTypeForm" class="ml-5 min-w-[2px] flex-grow">
      <ng-select
        #schemeTypeSelect
        [fixNgSelectBottom]="schemeTypeSelect"
        data-cy="schemeTypeSelect"
        class="text-base select-none"
        [items]="schemeTypesList"
        [clearable]="false"
        [searchable]="false"
        (change)="schemeTypeChange()"
        (keyup.esc)="$event.stopImmediatePropagation(); schemeTypeSelect.blur()"
        (keyup.enter)="
          $event.stopImmediatePropagation(); schemeTypeSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
        formControlName="schemeType"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 flex">{{ item.label }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 flex">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </form>
  </div> -->

    <!-- <div
    *ngIf="interpolationChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Interpolation</div
      >
    </div>

    <form [formGroup]="interpolationForm" class="ml-5 min-w-[2px] flex-grow">
      <ng-select
        #interpolationSelect
        [fixNgSelectBottom]="interpolationSelect"
        data-cy="interpolationSelect"
        class="text-base select-none"
        [items]="interpolationsList"
        [clearable]="false"
        [searchable]="false"
        (change)="interpolationChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); interpolationSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); interpolationSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
        formControlName="interpolation"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 flex">{{ item.label }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 flex">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </form>
  </div> -->

    <!-- <div
    *ngIf="cardColorChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Card Color</div
      >
    </div>

    <m-color-menu
      class="ml-5"
      [color]="chart.cardColor"
      (colorChange)="cardColorChange($event)"
    ></m-color-menu>
  </div> -->

    <!-- <div
    *ngIf="emptyColorChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Empty Card Color</div
      >
    </div>

    <m-color-menu
      class="ml-5"
      [color]="chart.emptyColor"
      (colorChange)="emptyColorChange($event)"
    ></m-color-menu>
  </div> -->

    <!-- <div
    *ngIf="bandColorChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Band Color</div
      >
    </div>

    <m-color-menu
      class="ml-5"
      [color]="chart.bandColor"
      (colorChange)="bandColorChange($event)"
    ></m-color-menu>
  </div> -->

    <!-- <div
    *ngIf="textColorChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Text Color</div
      >
    </div>

    <m-color-menu
      class="ml-5"
      [color]="chart.textColor"
      (colorChange)="textColorChange($event)"
    ></m-color-menu>
  </div> -->

    <!-- <div
    *ngIf="unitsChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Units</div
      >
    </div>

    <div [formGroup]="unitsForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorUnitsInput"
        class="form-input border-s3 focus:border-m600 h-9 w-56 rounded"
        [ngClass]="{
          'border-r600':
            unitsForm.controls['units'].invalid &&
            unitsForm.controls['units'].touched
        }"
        formControlName="units"
        (blur)="unitsBlur()"
      />
      <m-validation [control]="unitsForm.controls['units']"></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="legendTitleChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Legend Title</div
      >
    </div>

    <div
      *ngIf="
        chart.legend === true && chart.schemeType !== chartSchemeTypeEnum.Linear
      "
      [formGroup]="legendTitleForm"
      class="ml-5 flex flex-col items-start"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorLegendTitleInput"
        class="form-input border-s3 focus:border-m600 h-9 w-56 rounded"
        [ngClass]="{
          'border-r600':
            legendTitleForm.controls['legendTitle'].invalid &&
            legendTitleForm.controls['legendTitle'].touched
        }"
        formControlName="legendTitle"
        (blur)="legendTitleBlur()"
      />
      <m-validation
        [control]="legendTitleForm.controls['legendTitle']"
      ></m-validation>
    </div>

    <div
      *ngIf="
        chart.legend === false ||
        chart.schemeType === chartSchemeTypeEnum.Linear
      "
      class="text-s1 mb-6 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="xAxisLabelChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >X Axis Label</div
      >
    </div>

    <div
      *ngIf="chart.showXAxisLabel === true && chart.xAxis === true"
      [formGroup]="xAxisLabelForm"
      class="ml-5 flex flex-col items-start"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorXAxisLabelInput"
        class="form-input border-s3 focus:border-m600 h-9 w-56 rounded"
        [ngClass]="{
          'border-r600':
            xAxisLabelForm.controls['xAxisLabel'].invalid &&
            xAxisLabelForm.controls['xAxisLabel'].touched
        }"
        formControlName="xAxisLabel"
        (blur)="xAxisLabelBlur()"
      />
      <m-validation
        [control]="xAxisLabelForm.controls['xAxisLabel']"
      ></m-validation>
    </div>

    <div
      *ngIf="chart.showXAxisLabel === false || chart.xAxis === false"
      class="text-s1 mb-6 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="yAxisLabelChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Y Axis Label</div
      >
    </div>

    <div
      *ngIf="chart.showYAxisLabel === true && chart.yAxis === true"
      [formGroup]="yAxisLabelForm"
      class="ml-5 flex flex-col items-start"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorYAxisLabelInput"
        class="form-input border-s3 focus:border-m600 h-9 w-56 rounded"
        [ngClass]="{
          'border-r600':
            yAxisLabelForm.controls['yAxisLabel'].invalid &&
            yAxisLabelForm.controls['yAxisLabel'].touched
        }"
        formControlName="yAxisLabel"
        (blur)="yAxisLabelBlur()"
      />
      <m-validation
        [control]="yAxisLabelForm.controls['yAxisLabel']"
      ></m-validation>
    </div>

    <div
      *ngIf="chart.showYAxisLabel === false || chart.yAxis === false"
      class="text-s1 mb-6 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="labelsChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Labels</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.labels"
      (change)="toggleLabels($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="showDataLabelChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Show Data Label</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.showDataLabel"
      (change)="toggleShowDataLabel($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="legendChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Legend</div
    >

    <ui-switch
      *ngIf="chart.schemeType !== chartSchemeTypeEnum.Linear"
      class="ml-5"
      [checked]="chart.legend"
      (change)="toggleLegend($event)"
      color="#64BD63"
      ></ui-switch>

    <div
      *ngIf="chart.schemeType === chartSchemeTypeEnum.Linear"
      class="text-s1 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="doughnutChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Doughnut</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.doughnut"
      (change)="toggleDoughnut($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="explodeSlicesChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Explode Slices (doughnut off)</div
    >

    <ui-switch
      *ngIf="chart.doughnut === false"
      class="ml-5"
      [checked]="chart.explodeSlices"
      (change)="toggleExplodeSlices($event)"
      color="#64BD63"
      ></ui-switch>

    <div
      *ngIf="chart.doughnut === true"
      class="text-s1 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="xAxisChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >X Axis</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.xAxis"
      (change)="toggleXAxis($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="yAxisChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Y Axis</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.yAxis"
      (change)="toggleYAxis($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="showXAxisLabelChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Show X Axis Label</div
    >

    <ui-switch
      *ngIf="chart.xAxis === true"
      class="ml-5"
      [checked]="chart.showXAxisLabel"
      (change)="toggleShowXAxisLabel($event)"
      color="#64BD63"
      ></ui-switch>

    <div
      *ngIf="chart.xAxis === false"
      class="text-s1 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="showYAxisLabelChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Show Y Axis Label</div
    >

    <ui-switch
      *ngIf="chart.yAxis === true"
      class="ml-5"
      [checked]="chart.showYAxisLabel"
      (change)="toggleShowYAxisLabel($event)"
      color="#64BD63"
      ></ui-switch>

    <div
      *ngIf="chart.yAxis === false"
      class="text-s1 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="showAxisChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Show Axis</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.showAxis"
      (change)="toggleShowAxis($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="roundDomainsChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Round Domains</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.roundDomains"
      (change)="toggleRoundDomains($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="showGridLinesChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Show Grid Lines</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.showGridLines"
      (change)="toggleShowGridLines($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
  *ngIf="timelineChartTypes.indexOf(chart.type) > -1"
  class="flex flex-row items-center mb-5"
>
  <div class="flex h-9 w-48 text-s1 text-base items-center select-none"
    >Timeline</div
  >

  <ui-switch
    class="ml-5"
    [checked]="chart.timeline"
    (change)="toggleTimeline($event)"
    color="#64BD63"
    ></ui-switch>
</div> -->

    <!-- <div
    *ngIf="roundEdgesChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Round Bar Edges</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.roundEdges"
      (change)="toggleRoundEdges($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="tooltipDisabledChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Disable Tooltip</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.tooltipDisabled"
      (change)="toggleTooltipDisabled($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="gradientChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Gradient</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.gradient"
      (change)="toggleGradient($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="animationsChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Animations</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.animations"
      (change)="toggleAnimations($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="autoScaleChartTypes.indexOf(chart.type) > -1"
    class="mb-5 flex flex-row items-center"
  >
    <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
      >Auto Scale</div
    >

    <ui-switch
      class="ml-5 mt-1"
      [checked]="chart.autoScale"
      (change)="toggleAutoScale($event)"
      color="#64BD63"
      ></ui-switch>
  </div> -->

    <!-- <div
    *ngIf="angleSpanChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Angle Span</div
      >
    </div>

    <div [formGroup]="angleSpanForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorAngleSpanInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            angleSpanForm.controls['angleSpan'].invalid &&
            angleSpanForm.controls['angleSpan'].touched
        }"
        formControlName="angleSpan"
        (blur)="angleSpanBlur()"
      />
      <m-validation
        [control]="angleSpanForm.controls['angleSpan']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="startAngleChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Start Angle</div
      >
    </div>

    <div [formGroup]="startAngleForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorStartAngleInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            startAngleForm.controls['startAngle'].invalid &&
            startAngleForm.controls['startAngle'].touched
        }"
        formControlName="startAngle"
        (blur)="startAngleBlur()"
      />
      <m-validation
        [control]="startAngleForm.controls['startAngle']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="arcWidthChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Arc Width (doughnut)</div
      >
    </div>

    <div
      *ngIf="chart.doughnut === true"
      [formGroup]="arcWidthForm"
      class="ml-5 flex flex-col items-start"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorArcWidthInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            arcWidthForm.controls['arcWidth'].invalid &&
            arcWidthForm.controls['arcWidth'].touched
        }"
        formControlName="arcWidth"
        (blur)="arcWidthBlur()"
      />
      <m-validation
        [control]="arcWidthForm.controls['arcWidth']"
      ></m-validation>
    </div>

    <div
      *ngIf="chart.doughnut === false"
      class="text-s1 mb-6 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="minChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Min</div
      >
    </div>

    <div [formGroup]="minForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorMinInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            minForm.controls['min'].invalid && minForm.controls['min'].touched
        }"
        formControlName="min"
        (blur)="minBlur()"
      />
      <m-validation [control]="minForm.controls['min']"></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="maxChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Max</div
      >
    </div>

    <div [formGroup]="maxForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorMaxInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            maxForm.controls['max'].invalid && maxForm.controls['max'].touched
        }"
        formControlName="max"
        (blur)="maxBlur()"
      />
      <m-validation [control]="maxForm.controls['max']"></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="xScaleMaxChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >X Scale Max</div
      >
    </div>

    <div [formGroup]="xScaleMaxForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorXScaleMaxInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            xScaleMaxForm.controls['xScaleMax'].invalid &&
            xScaleMaxForm.controls['xScaleMax'].touched
        }"
        formControlName="xScaleMax"
        (blur)="xScaleMaxBlur()"
      />
      <m-validation
        [control]="xScaleMaxForm.controls['xScaleMax']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="yScaleMinChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Y Scale Min</div
      >
    </div>

    <div
      *ngIf="chart.autoScale === false"
      [formGroup]="yScaleMinForm"
      class="ml-5 flex flex-col items-start"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorYScaleMinInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            yScaleMinForm.controls['yScaleMin'].invalid &&
            yScaleMinForm.controls['yScaleMin'].touched
        }"
        formControlName="yScaleMin"
        (blur)="yScaleMinBlur()"
      />
      <m-validation
        [control]="yScaleMinForm.controls['yScaleMin']"
      ></m-validation>
    </div>

    <div
      *ngIf="chart.autoScale === true"
      class="text-s1 mb-6 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="yScaleMaxChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Y Scale Max</div
      >
    </div>

    <div
      *ngIf="chart.autoScale === false"
      [formGroup]="yScaleMaxForm"
      class="ml-5 flex flex-col items-start"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorYScaleMaxInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            yScaleMaxForm.controls['yScaleMax'].invalid &&
            yScaleMaxForm.controls['yScaleMax'].touched
        }"
        formControlName="yScaleMax"
        (blur)="yScaleMaxBlur()"
      />
      <m-validation
        [control]="yScaleMaxForm.controls['yScaleMax']"
      ></m-validation>
    </div>

    <div
      *ngIf="chart.autoScale === true"
      class="text-s1 mb-6 ml-5 flex h-9 select-none items-center text-base"
      ><m-minus-sm-icon></m-minus-sm-icon
    ></div>
  </div> -->

    <!-- <div
    *ngIf="barPaddingChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Padding between bars</div
      >
    </div>

    <div [formGroup]="barPaddingForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorBarPaddingInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            barPaddingForm.controls['barPadding'].invalid &&
            barPaddingForm.controls['barPadding'].touched
        }"
        formControlName="barPadding"
        (blur)="barPaddingBlur()"
      />
      <m-validation
        [control]="barPaddingForm.controls['barPadding']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="bigSegmentsChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Big Segments</div
      >
    </div>

    <div [formGroup]="bigSegmentsForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorBigSegmentsInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            bigSegmentsForm.controls['bigSegments'].invalid &&
            bigSegmentsForm.controls['bigSegments'].touched
        }"
        formControlName="bigSegments"
        (blur)="bigSegmentsBlur()"
      />
      <m-validation
        [control]="bigSegmentsForm.controls['bigSegments']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="smallSegmentsChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Small Segments</div
      >
    </div>

    <div [formGroup]="smallSegmentsForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorSmallSegmentsInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            smallSegmentsForm.controls['smallSegments'].invalid &&
            smallSegmentsForm.controls['smallSegments'].touched
        }"
        formControlName="smallSegments"
        (blur)="smallSegmentsBlur()"
      />
      <m-validation
        [control]="smallSegmentsForm.controls['smallSegments']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="groupPaddingChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Group Padding</div
      >
    </div>

    <div [formGroup]="groupPaddingForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorGroupPaddingInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            groupPaddingForm.controls['groupPadding'].invalid &&
            groupPaddingForm.controls['groupPadding'].touched
        }"
        formControlName="groupPadding"
        (blur)="groupPaddingBlur()"
      />
      <m-validation
        [control]="groupPaddingForm.controls['groupPadding']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="innerPaddingChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Inner Padding</div
      >
    </div>

    <div [formGroup]="innerPaddingForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorInnerPaddingInput"
        class="form-input border-s3 focus:border-m600 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            innerPaddingForm.controls['innerPadding'].invalid &&
            innerPaddingForm.controls['innerPadding'].touched
        }"
        formControlName="innerPadding"
        (blur)="innerPaddingBlur()"
      />
      <m-validation
        [control]="innerPaddingForm.controls['innerPadding']"
      ></m-validation>
    </div>
  </div> -->

    <!-- <div
    *ngIf="formatNumberDataLabelChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Format # Data Label</div
      >
    </div>

    <form
      [formGroup]="formatNumberDataLabelForm"
      class="ml-5 flex min-w-[2px] flex-grow flex-col items-start"
    >
    <ng-select
        #formatNumberDataLabelSelect  
        [fixNgSelectBottom]="formatNumberDataLabelSelect"
        data-cy="formatNumberDataLabelSelect"
        class="w-full text-base select-none"
        [items]="formatNumberExamples"
        [clearable]="false"
        [searchable]="false"
        (change)="formatNumberDataLabelBlur()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); formatNumberDataLabelSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); formatNumberDataLabelSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="id"
        formControlName="formatNumberDataLabel"
      >
        <ng-template ng-label-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="false"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="true"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>
      </ng-select>

      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorFormatNumberDataLabelInput"
        class="form-input border-s3 focus:border-m600 mt-5 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            formatNumberDataLabelForm.controls['formatNumberDataLabel']
              .invalid &&
            formatNumberDataLabelForm.controls['formatNumberDataLabel'].touched
        }"
        formControlName="formatNumberDataLabel"
        (blur)="formatNumberDataLabelBlur()"
      />
      <m-validation
        [control]="formatNumberDataLabelForm.controls['formatNumberDataLabel']"
      ></m-validation>
    </form>
  </div> -->

    <!-- <div
    *ngIf="formatNumberValueChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Format # Value</div
      >
    </div>

    <form
      [formGroup]="formatNumberValueForm"
      class="ml-5 flex min-w-[2px] flex-grow flex-col items-start"
    >
      <ng-select
        #formatNumberValueSelect
        [fixNgSelectBottom]="formatNumberValueSelect"
        data-cy="formatNumberValueSelect"
        class="w-full text-base select-none"
        [items]="formatNumberExamples"
        [clearable]="false"
        [searchable]="false"
        (change)="formatNumberValueBlur()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); formatNumberValueSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); formatNumberValueSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="id"
        formControlName="formatNumberValue"
      >
        <ng-template ng-label-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="false"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="true"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>
      </ng-select>

      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorFormatNumberValueInput"
        class="form-input border-s3 focus:border-m600 mt-5 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            formatNumberValueForm.controls['formatNumberValue'].invalid &&
            formatNumberValueForm.controls['formatNumberValue'].touched
        }"
        formControlName="formatNumberValue"
        (blur)="formatNumberValueBlur()"
      />
      <m-validation
        [control]="formatNumberValueForm.controls['formatNumberValue']"
      ></m-validation>
    </form>
  </div> -->

    <!-- <div
    *ngIf="formatNumberAxisTickChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Format # Axis Tick</div
      >
    </div>

    <form
      [formGroup]="formatNumberAxisTickForm"
      class="ml-5 flex min-w-[2px] flex-grow flex-col items-start"
    >
      <ng-select
        #formatNumberAxisTickSelect
        [fixNgSelectBottom]="formatNumberAxisTickSelect"
        data-cy="formatNumberAxisTickSelect"
        class="w-full text-base select-none"
        [items]="formatNumberExamples"
        [clearable]="false"
        [searchable]="false"
        (change)="formatNumberAxisTickBlur()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); formatNumberAxisTickSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); formatNumberAxisTickSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="id"
        formControlName="formatNumberAxisTick"
      >
        <ng-template ng-label-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="false"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="true"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>
      </ng-select>

      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorFormatNumberAxisTickInput"
        class="form-input border-s3 focus:border-m600 mt-5 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            formatNumberAxisTickForm.controls['formatNumberAxisTick'].invalid &&
            formatNumberAxisTickForm.controls['formatNumberAxisTick'].touched
        }"
        formControlName="formatNumberAxisTick"
        (blur)="formatNumberAxisTickBlur()"
      />
      <div class="min-w-[2px] flex-grow"> </div>

      <m-validation
        [control]="formatNumberAxisTickForm.controls['formatNumberAxisTick']"
      ></m-validation>
    </form>
  </div> -->

    <!-- <div
    *ngIf="formatNumberXAxisTickChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Format # X Axis Tick</div
      >
    </div>

    <form
      [formGroup]="formatNumberXAxisTickForm"
      class="ml-5 flex min-w-[2px] flex-grow flex-col items-start"
    >
      <ng-select
        #formatNumberXAxisTickSelect
        [fixNgSelectBottom]="formatNumberXAxisTickSelect"
        data-cy="formatNumberXAxisTickSelect"
        class="w-full text-base select-none"
        [items]="formatNumberExamples"
        [clearable]="false"
        [searchable]="false"
        (change)="formatNumberXAxisTickBlur()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); formatNumberXAxisTickSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); formatNumberXAxisTickSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="id"
        formControlName="formatNumberXAxisTick"
      >
        <ng-template ng-label-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="false"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="true"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>
      </ng-select>

      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorFormatNumberXAxisTickInput"
        class="form-input border-s3 focus:border-m600 mt-5 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            formatNumberXAxisTickForm.controls['formatNumberXAxisTick']
              .invalid &&
            formatNumberXAxisTickForm.controls['formatNumberXAxisTick'].touched
        }"
        formControlName="formatNumberXAxisTick"
        (blur)="formatNumberXAxisTickBlur()"
      />
      <m-validation
        [control]="formatNumberXAxisTickForm.controls['formatNumberXAxisTick']"
      ></m-validation>
    </form>
  </div> -->

    <!-- <div
    *ngIf="formatNumberYAxisTickChartTypes.indexOf(chart.type) > -1"
    class="flex flex-row items-start"
  >
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-48 select-none items-center text-base"
        >Format # Y Axis Tick</div
      >
    </div>

    <form
      [formGroup]="formatNumberYAxisTickForm"
      class="ml-5 flex min-w-[2px] flex-grow flex-col items-start"
    >
      <ng-select
        [fixNgSelectBottom]="formatNumberYAxisTickSelect"
        #formatNumberYAxisTickSelect
        data-cy="formatNumberYAxisTickSelect"
        class="w-full text-base select-none"
        [items]="formatNumberExamples"
        [clearable]="false"
        [searchable]="false"
        (change)="formatNumberYAxisTickBlur()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); formatNumberYAxisTickSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); formatNumberYAxisTickSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="id"
        formControlName="formatNumberYAxisTick"
      >
        <ng-template ng-label-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="false"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <m-format-number
            [inputItem]="item"
            [isOption]="true"
            class="ml-1 flex"
          ></m-format-number>
        </ng-template>
      </ng-select>

      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartEditorFormatNumberYAxisTickInput"
        class="form-input border-s3 focus:border-m600 mt-5 h-9 w-32 rounded"
        [ngClass]="{
          'border-r600':
            formatNumberYAxisTickForm.controls['formatNumberYAxisTick']
              .invalid &&
            formatNumberYAxisTickForm.controls['formatNumberYAxisTick'].touched
        }"
        formControlName="formatNumberYAxisTick"
        (blur)="formatNumberYAxisTickBlur()"
      />
      <m-validation
        [control]="formatNumberYAxisTickForm.controls['formatNumberYAxisTick']"
      ></m-validation>
    </form>
  </div> -->
  </ng-container>
</div>
